import { z } from "zod";

export const passkeyRegisterSchema = z.object({
    friendlyName: z
        .string()
        .min(1, "Give your passkey a name")
        .max(100, "Name must be 100 characters or fewer"),
});

export const passkeyRenameSchema = z.object({
    friendlyName: z
        .string()
        .min(1, "Name is required")
        .max(100, "Name must be 100 characters or fewer"),
});